import useDialog from './composables/use-payment';
import PaymentDialog from './payment-dialog.vue';

export const usePayment = useDialog;
export default PaymentDialog;